var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-profile-sidebar-title",style:({gridTemplateColumns: _setup.templateColumns})},_vm._l((_setup.divs),function(div){return _c('span',{key:div.str,staticClass:"bcx-one-line",class:{'bcx-truncated-text': div.isUserName},domProps:{"innerHTML":_vm._s(div.str)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }